import {PageContext} from '../../context/PageContext'
import {PanelContext} from '../../context/PanelContext'
import {Section} from '../Section'
import {DebugData} from '../Debugger'

import type {EufePageFragment} from '@sdox/api'

interface EufePageProps {
  page: EufePageFragment
}

export const EufePage = (props: EufePageProps) => {
  const {page} = props

  return (
    <PanelContext.Provider value={{panels: page.panels}}>
      <PageContext.Provider value={{page}}>
        <Section.Template
          key={page.id}
          id={page.id}
          callout={page.callout ?? undefined}
          title={page.name ?? undefined}
          subTitle={page.subtitle ?? undefined}
        >
          {page.panels.map(panel => (
            <PanelContext.Provider
              value={{panels: [panel]}}
              key={panel.id}
            >
              <Section.BlocksTemplate
                allowTopPullout={!page.name && !page.subtitle && !page.callout}
                blocks={panel.blocks}
              />
            </PanelContext.Provider>
          ))}

          <DebugData data={page}/>
        </Section.Template>
      </PageContext.Provider>
    </PanelContext.Provider>
  )
}
